'use strict';

var FileSaver = require('file-saver');
const Blob = window.Blob;
const XMLHttpRequest = window.XMLHttpRequest;
var $hiddenForm = $('#get-pdf');
var $siteInput = $hiddenForm.find('input[name="site"]');

function getFilenameFromContentDisposition (dispositionString) {
  var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  var matches = filenameRegex.exec(dispositionString);
  var filename = dispositionString;
  if (matches != null && matches[1]) {
    filename = matches[1].replace(/['"]/g, '');
  }
  return filename;
}

$(document.body).on('click', '.js-download-pdf', function (event) {
  event.preventDefault();
  var $this = $(this);
  var site = $this.data('site');
  var type = $this.data('type');
  var id = $this.data('templateId');
  var lang = $this.data('lang');

  $('form#get-pdf input[name=lang]').remove();
  $('form#get-pdf input[name=template]').remove();
  $('form#get-pdf input[name=template-lang]').remove();

  if (id) {
    $hiddenForm.append('<input type="hidden" name="template" value="' + id + '">');
  } else {
    $hiddenForm.append('<input type="hidden" name="template-lang" value="' + window.wooGlobal.language + '">');
  }

  if (lang) {
    $hiddenForm.append('<input type="hidden" name="lang" value="' + lang + '">');
  }

  if (!$this.hasClass('busy')) {
    $this.addClass('busy');
    $this.parents('.js-async-container').find('.js-btn-async').addClass('busy');
    $siteInput.val(site);
    var params = $hiddenForm.serialize() + '&typeSubmit=' + type;
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function (e) {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          var blob = new Blob([xhr.response], {type: 'application/pdf'});
          var filename = getFilenameFromContentDisposition(xhr.getResponseHeader('Content-Disposition'));
          FileSaver.saveAs(blob, filename);
        } else {
          window.Raven.captureMessage('Pdf fetching error', {
            extra: {
              site: site,
              type: type,
              user: window.wooGlobal.user,
              status: xhr.statusText
            }
          });
          $('#generic-error-modal').modal('show');
        }
        if ($this.hasClass('busy')) {
          $this.removeClass('busy');
          $this.parents('.js-async-container').find('.js-btn-async').removeClass('busy');
        }
      }
    };
    xhr.open('POST', $hiddenForm.attr('action'));
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.responseType = 'arraybuffer';
    xhr.send(params);
  }
});
